import { BuilderBlockProps } from "@/types";
import { FC, PropsWithChildren } from "react";

const TableRow: FC<PropsWithChildren<Partial<BuilderBlockProps>>> = ({
  children,
  attributes,
}) => <tr {...attributes}>{children}</tr>;

export default TableRow;
